'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

var _JourneyHeader = require('./JourneyHeader.jsx');

var _JourneyHeader2 = _interopRequireDefault(_JourneyHeader);

var _AvailJourney = require('./AvailJourney.jsx');

var _AvailJourney2 = _interopRequireDefault(_AvailJourney);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailJourneys(props) {
  var components = props.components,
      journeys = props.journeys,
      origin = props.origin,
      destination = props.destination,
      departure = props.departure;


  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'AvailJourneys' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: _emailStyleTools.noPad },
          _react2.default.createElement(_JourneyHeader2.default, {
            from: origin,
            to: destination,
            departure: departure
          })
        )
      ),
      journeys.map(function (journey, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: _emailStyleTools.noPad },
            _react2.default.createElement(
              'table',
              { style: _emailStyleTools.fullMinimal, 'data-component': 'AvailJourneys__map' },
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { style: _emailStyleTools.noPad },
                    _react2.default.createElement(_AvailJourney2.default, { journey: journey })
                  )
                ),
                i < journeys.length - 1 ? _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', { style: { backgroundColor: '#666', height: '2px', padding: '0' } })
                ) : null
              )
            )
          )
        );
      })
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(AvailJourneys);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AvailJourneys.jsx
// module id = 1472
// module chunks = 0